var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlayBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 37,
    viewBox: "0 0 123 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.455556,
    y: 0.733388,
    width: 122.089,
    height: 35.5333,
    rx: 5.92222,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.455556,
    y: 0.733388,
    width: 122.089,
    height: 35.5333,
    rx: 5.92222,
    stroke: "#A6A6A6",
    strokeWidth: 0.911111
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5802 11.5178C46.5802 12.14 46.3894 12.6383 46.0135 13.01C45.5813 13.4506 45.0184 13.6723 44.3287 13.6723C43.6694 13.6723 43.1065 13.4469 42.6448 13.0025C42.182 12.5517 41.9512 11.9984 41.9512 11.3361C41.9512 10.6739 42.182 10.1206 42.6448 9.67346C43.1065 9.22542 43.6694 9 44.3287 9C44.6568 9 44.9698 9.06613 45.2684 9.18909C45.566 9.31298 45.8084 9.48064 45.9839 9.68743L45.5851 10.0805C45.2789 9.72748 44.862 9.5533 44.3287 9.5533C43.8478 9.5533 43.4309 9.71724 43.0769 10.0479C42.7268 10.3795 42.5513 10.8089 42.5513 11.3361C42.5513 11.8634 42.7268 12.2965 43.0769 12.6281C43.4309 12.955 43.8478 13.1227 44.3287 13.1227C44.8391 13.1227 45.2684 12.955 45.6071 12.6244C45.8303 12.4055 45.9572 12.1037 45.9906 11.718H44.3287V11.1797H46.5459C46.5726 11.2961 46.5802 11.4088 46.5802 11.5178Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0981 9.65069H48.0154V11.0665H49.8929V11.6049H48.0154V13.0208H50.0981V13.5694H47.4258V9.10205H50.0981V9.65069Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.58 13.5694H51.9904V9.65069H50.7129V9.10205H53.8584V9.65069H52.58V13.5694Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1348 13.5694V9.10205H56.7234V13.5694H56.1348Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3329 13.5694H58.7481V9.65069H57.4658V9.10205H60.6151V9.65069H59.3329V13.5694Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5699 13.1367C66.1186 13.5885 65.5595 13.8139 64.8926 13.8139C64.222 13.8139 63.6629 13.5885 63.2116 13.1367C62.7613 12.6859 62.5371 12.1326 62.5371 11.4777C62.5371 10.8229 62.7613 10.2696 63.2116 9.81878C63.6629 9.36702 64.222 9.1416 64.8926 9.1416C65.5557 9.1416 66.1148 9.36702 66.566 9.82251C67.0202 10.2771 67.2444 10.8266 67.2444 11.4777C67.2444 12.1326 67.0202 12.6859 66.5699 13.1367ZM63.6476 12.7622C63.9873 13.0966 64.4004 13.2643 64.8926 13.2643C65.3811 13.2643 65.798 13.0966 66.1339 12.7622C66.4725 12.4278 66.6443 11.9984 66.6443 11.4777C66.6443 10.957 66.4725 10.5276 66.1339 10.1932C65.798 9.85884 65.3811 9.69117 64.8926 9.69117C64.4004 9.69117 63.9873 9.85884 63.6476 10.1932C63.3089 10.5276 63.1372 10.957 63.1372 11.4777C63.1372 11.9984 63.3089 12.4278 63.6476 12.7622Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0723 13.5694V9.10205H68.7878L71.0126 12.5765H71.0384L71.0126 11.7176V9.10205H71.6013V13.5694H70.9869L68.6571 9.92361H68.6313L68.6571 10.7862V13.5694H68.0723Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3928 20.2356C60.6001 20.2356 59.1357 21.5676 59.1357 23.4054C59.1357 25.2283 60.6001 26.5743 62.3928 26.5743C64.1892 26.5743 65.6537 25.2283 65.6537 23.4054C65.6537 21.5676 64.1892 20.2356 62.3928 20.2356ZM62.3928 25.3261C61.4092 25.3261 60.5629 24.5334 60.5629 23.4054C60.5629 22.2625 61.4092 21.4838 62.3928 21.4838C63.3764 21.4838 64.2264 22.2625 64.2264 23.4054C64.2264 24.5334 63.3764 25.3261 62.3928 25.3261ZM55.2861 20.2356C53.4896 20.2356 52.029 21.5676 52.029 23.4054C52.029 25.2283 53.4896 26.5743 55.2861 26.5743C57.0816 26.5743 58.5432 25.2283 58.5432 23.4054C58.5432 21.5676 57.0816 20.2356 55.2861 20.2356ZM55.2861 25.3261C54.3015 25.3261 53.4524 24.5334 53.4524 23.4054C53.4524 22.2625 54.3015 21.4838 55.2861 21.4838C56.2697 21.4838 57.1159 22.2625 57.1159 23.4054C57.1159 24.5334 56.2697 25.3261 55.2861 25.3261ZM46.8294 21.2071V22.554H50.1237C50.0274 23.3067 49.7698 23.86 49.3748 24.2456C48.894 24.7113 48.1451 25.2283 46.8294 25.2283C44.8021 25.2283 43.2146 23.6308 43.2146 21.6514C43.2146 19.672 44.8021 18.0746 46.8294 18.0746C47.9256 18.0746 48.7232 18.4928 49.3119 19.0349L50.284 18.0857C49.4607 17.3182 48.3654 16.7286 46.8294 16.7286C44.0493 16.7286 41.7129 18.9371 41.7129 21.6514C41.7129 24.3657 44.0493 26.5743 46.8294 26.5743C48.3321 26.5743 49.4607 26.0936 50.348 25.192C51.2572 24.3043 51.5405 23.0561 51.5405 22.0482C51.5405 21.7353 51.5138 21.4474 51.4661 21.2071H46.8294ZM81.4098 22.2513C81.1417 21.5424 80.3145 20.2356 78.6297 20.2356C76.9601 20.2356 75.57 21.5201 75.57 23.4054C75.57 25.1808 76.9458 26.5743 78.7899 26.5743C80.2811 26.5743 81.1417 25.6866 81.4956 25.1696L80.3889 24.4496C80.0197 24.9768 79.5169 25.3261 78.7899 25.3261C78.0677 25.3261 77.5497 25.0029 77.2177 24.3657L81.5595 22.6118L81.4098 22.2513ZM76.983 23.3067C76.9458 22.0846 77.9552 21.4586 78.6783 21.4586C79.245 21.4586 79.7259 21.7353 79.8861 22.1311L76.983 23.3067ZM73.454 26.3815H74.8812V17.0667H73.454V26.3815ZM71.1166 20.9416H71.0689C70.7483 20.5709 70.1368 20.2356 69.3621 20.2356C67.7364 20.2356 66.25 21.6291 66.25 23.4156C66.25 25.192 67.7364 26.5743 69.3621 26.5743C70.1368 26.5743 70.7483 26.2361 71.0689 25.8542H71.1166V26.3088C71.1166 27.5206 70.4535 28.1717 69.384 28.1717C68.512 28.1717 67.9711 27.557 67.7478 27.04L66.5066 27.5458C66.8644 28.386 67.8117 29.4199 69.384 29.4199C71.0574 29.4199 72.4694 28.4586 72.4694 26.1197V20.4284H71.1166V20.9416ZM69.4842 25.3261C68.5006 25.3261 67.6772 24.5222 67.6772 23.4156C67.6772 22.2988 68.5006 21.4838 69.4842 21.4838C70.4535 21.4838 71.2177 22.2988 71.2177 23.4156C71.2177 24.5222 70.4535 25.3261 69.4842 25.3261ZM88.0919 17.0667H84.6783V26.3815H86.1017V22.8521H88.0919C89.6727 22.8521 91.2231 21.7353 91.2231 19.9589C91.2231 18.1835 89.6689 17.0667 88.0919 17.0667ZM88.1291 21.5564H86.1017V18.3624H88.1291C89.1919 18.3624 89.7987 19.224 89.7987 19.9589C89.7987 20.6799 89.1919 21.5564 88.1291 21.5564ZM96.9282 20.2179C95.8998 20.2179 94.8303 20.6613 94.3905 21.644L95.6536 22.1609C95.9255 21.644 96.4255 21.4763 96.954 21.4763C97.6924 21.4763 98.4414 21.9094 98.4528 22.6742V22.772C98.1952 22.6267 97.6438 22.4115 96.9655 22.4115C95.605 22.4115 94.2188 23.1427 94.2188 24.5073C94.2188 25.7555 95.3331 26.5594 96.5857 26.5594C97.5436 26.5594 98.0721 26.1374 98.4042 25.6465H98.4528V26.3665H99.8276V22.7934C99.8276 21.1419 98.5644 20.2179 96.9282 20.2179ZM96.7565 25.3224C96.2909 25.3224 95.6422 25.097 95.6422 24.5334C95.6422 23.8124 96.4512 23.5358 97.1515 23.5358C97.7783 23.5358 98.0721 23.6709 98.4528 23.8488C98.3412 24.7113 97.5808 25.3224 96.7565 25.3224ZM104.836 20.4219L103.2 24.4598H103.151L101.46 20.4219H99.9249L102.466 26.0648L101.016 29.2048H102.504L106.42 20.4219H104.836ZM92.0054 26.3815H93.4326V17.0667H92.0054V26.3815Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3539 9.50167C18.1297 9.73082 18 10.0876 18 10.5496V27.0292C18 27.4912 18.1297 27.848 18.3539 28.0771L18.4093 28.1274L27.8677 18.8965V18.6786L18.4093 9.44765L18.3539 9.50167Z",
    fill: "url(#paint0_linear_8234_14464)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0165 21.9751L27.8672 18.8966V18.6786L31.0203 15.6001L31.0909 15.6401L34.825 17.7145C35.8907 18.3032 35.8907 19.272 34.825 19.8644L31.0909 21.935L31.0165 21.9751Z",
    fill: "url(#paint1_linear_8234_14464)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M31.091 21.9356L27.8673 18.7881L18.3535 28.0777C18.7075 28.441 19.2847 28.4848 19.941 28.1215L31.091 21.9356Z",
    fill: "url(#paint2_linear_8234_14464)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.091 15.6401L19.941 9.45422C19.2847 9.09468 18.7075 9.13845 18.3535 9.50173L27.8673 18.7876L31.091 15.6401Z",
    fill: "url(#paint3_linear_8234_14464)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8234_14464",
    x1: 27.0279,
    y1: 27.2008,
    x2: 14.5256,
    y2: 14.3956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8234_14464",
    x1: 36.2127,
    y1: 18.7865,
    x2: 17.7448,
    y2: 18.7865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8234_14464",
    x1: 29.338,
    y1: 17.0771,
    x2: 12.3839,
    y2: -0.287869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8234_14464",
    x1: 15.9587,
    y1: 33.5599,
    x2: 23.5295,
    y2: 25.8057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBadge);
export default __webpack_public_path__ + "static/media/google-play-badge.e3c4b57efd3557e4263fc8cb59a25b15.svg";
export { ForwardRef as ReactComponent };